import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { FORM_MODIFICACION_LLENADO_SILOS } from '../../../config/forms'
import * as actions from '../actions'
import { OperacionesModificacionLlenadoSiloDialogView } from '../components/OperacionesModificacionLlenadoSiloDialogView'

class OperacionesModificacionLlenadoSiloDialog extends Component {
  render () {
    const { silo, colorEtiqueta, isNewEtiqueta, setEtiquetaAsNew } = this.props
    return (
      <OperacionesModificacionLlenadoSiloDialogView
        silo={silo}
        colorEtiqueta={colorEtiqueta}
        isNewEtiqueta={isNewEtiqueta}
        setEtiquetaAsNew={setEtiquetaAsNew}
        etiquetaSeleccionada={this.props.etiquetaSeleccionada}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    silo: state.movimientoSilos.siloOperando,
    colorEtiqueta: state.movimientoSilos.colorEtiqueta,
    isNewEtiqueta: state.movimientoSilos.isNewEtiqueta
  }
}
export default connect(mapStateToProps, actions)(reduxForm({
  form: FORM_MODIFICACION_LLENADO_SILOS,
  initialValues: {},
  enableReinitialize: true
})(OperacionesModificacionLlenadoSiloDialog))
